import { useEffect, useState, useRef } from "react";
import { animate, useInView } from "framer-motion";

export default function AnimateNumber({ to, duration = 2 }) {
    const [value, setValue] = useState(0);
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, amount: 0.8 });

    useEffect(() => {
        if (isInView) {
            const controls = animate(0, to, {
                duration,
                onUpdate: (latest) => setValue(Math.floor(latest)),
            });
            return () => controls.stop();
        }
    }, [isInView, to, duration]);

    return <span ref={ref}>{value.toLocaleString('es-MX')}</span>;
}
